import { combineReducers } from 'redux';
import personsReducer from './PersonsReducer';
import queryReducer from './QueryReducer';
import communityPageReducer from './CommunityPageReducer';
import agendaReducer from './AgendaReducer';
import speakerReducer from './SpeakerReducer';
import userProfilePageReducer from './UserProfilePageReducer';
import inboxReducer from './InboxReducer';
import meReducer from './MeReducer';
import eventReducer from './EventReducer';
import siteConfReducer from './SiteConfReducer';
import settingsReducer from './SettingsReducer';
import sessionReducer from './SessionReducer';
import sponsorsReducer from './SponsorReducers';
import ringReducer from './RingReducer';
import loginReducer from './LoginReducer';

export default combineReducers({
    meReducer,
    eventReducer,
    personsReducer,
    queryReducer,
    communityPageReducer,
    agendaReducer,
    userProfilePageReducer,
    inboxReducer,
    siteConfReducer,
    settingsReducer,
    speakerReducer,
    sessionReducer,
    sponsorsReducer,
    ringReducer,
    loginReducer,
});
